import styled, { css } from 'styled-components'
import { icons, logos } from 'common'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/gameplay.css */
  .game_header.iw {
    margin-top: 20px;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .game_header.iw .asset_display {
    background: hsla(0, 0%, 100%, 0.05);
    max-width: 180px;
    width: 180px;
    height: fit-content;
    border-radius: 0 10px 10px 0;
    line-height: 100%;
    padding: 10px 15px;
    white-space: nowrap;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
  }
  .current_price_display {
    border-radius: 10px;
    line-height: 100%;
    padding: 14px 18px;
    height: fit-content;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .current_price_display label {
    font-size: 1.7rem;
    font-weight: 500;
    letter-spacing: -0.02em;
  }
  .game_header.iw .current_price_display .price_direction_icon {
    mask: url(${icons.bid_direction_icon}) center center / auto 18px no-repeat;
    width: 18px;
    height: 18px;
    margin: 0 5px 0 0;
  }
  /* UP */

  .game_header.iw .current_price_display.up label {
    color: hsl(126, 100%, 38%);
  }
  .game_header.iw .current_price_display .price_direction_icon.up {
    background: hsl(126, 100%, 38%);
    transform: rotate(-180deg);
  }

  /* DOWN */
  .game_header.iw .current_price_display.down label {
    color: hsl(340, 88%, 46%);
  }
  .game_header.iw .current_price_display .price_direction_icon.down {
    background: hsl(340, 88%, 46%);
    transform: rotate(0deg);
  }

  /* NEUTRAL */
  .game_header.iw .current_price_display.neutral label {
    color: hsl(221, 73%, 47%);
  }
  .game_header.iw .current_price_display .price_direction_icon.neutral {
    background: hsl(221, 73%, 47%);
    mask: url(${icons.bid_direction_neutral_icon}) center center / auto 22px
      no-repeat;
    width: 22px;
    height: 22px;
    margin: 0 5px 0 0;
  }
  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/res.css */
  @media (max-width: 1200px) {
    .game_header.iw {
      margin-top: 70px;
    }
  }
  @media (max-width: 800px) {
    .game_header.iw {
      height: auto;
      flex-direction: row;
      flex-wrap: wrap;
    }
    .game_header.iw .current_price_display {
      border-radius: 0 0 10px 10px;
      padding: 8px 15px;
      order: 2;
      width: 100%;
    }
    .game_header.iw .current_price_display label {
      font-size: 1.5rem;
    }
    .game_header.iw .asset_display {
      border-radius: 0 10px 0 0;
      order: 1;
      width: 50%;
      max-width: 50%;
      padding: 7px 15px;
      min-height: 32px;
    }
    .game_header.iw .volume_display {
      border-radius: 10px 0 0 0;
      border-right: 1px solid hsla(0, 0%, 100%, 0.2);
      padding: 7px 15px;
      order: 1;
      width: 50%;
      max-width: 50%;
      min-height: 32px;
    }
    .game_header.iw .current_price_display label {
      font-size: 1.4rem;
      letter-spacing: -0.03em;
    }
  }
  @media (max-width: 600px) {
    .game_header.iw {
      flex-direction: column;
      width: 100%;
    }
    .game_header.iw .current_price_display {
      border-radius: 0 0 10px 10px;
      order: 3;
      width: 100%;
    }
    .game_header.iw .current_price_display label {
      font-size: 1.3rem;
    }
    .game_header.iw .asset_display {
      border-radius: 0;
      order: 2;
      width: 100%;
      max-width: 100%;
    }
    .game_header.iw .volume_display {
      border-radius: 10px 10px 0 0;
      order: 1;
      width: 100%;
      max-width: 100%;
      border-right: 0;
      border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
    }
  }
  @media (max-width: 430px) {
    .game_header.iw .volume_display {
      display: none;
    }
    .game_header.iw .current_price_display {
      padding: 5px 15px;
    }
    .game_header.iw .current_price_display label {
      font-size: 1rem;
    }
    .game_header.iw {
      width: 70%;
    }
    .game_header.iw .asset_display {
      min-height: auto;
    }
  }
  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/wsb_theme.css */
  * {
    font-weight: 400;
    color: #fff;
  }
  .game_header.iw .asset_display {
    background: hsla(0, 0%, 100%, 0.1);
    border: 1px solid hsla(0, 0%, 100%, 0.1);
    backdrop-filter: blur(10px);
    border-right: 0;
  }
  .current_price_display {
    background: hsla(0, 0%, 100%, 0.1);
    border: 1px solid hsla(0, 0%, 100%, 0.1);
    backdrop-filter: blur(10px);
    border-left: 0;
  }
  .game_header.iw {
    position: fixed;
    top: 10px;
    left: 50%;
    transform: translate(-50%, 100%);
    margin-top: 15px;
    z-index: 999;
  }
  .game_header.iw .asset_display {
    max-width: 250px;
    width: 250px;
    border-radius: 10px 0 0 10px;
    justify-content: flex-start;
  }
  .current_price_display {
    border-radius: 0 10px 10px 0;
    padding: 8px 14px;
    max-width: 270px;
    width: 270px;
    justify-content: flex-end;
  }
  .current_price_display label {
    font-size: 1.2rem;
    font-weight: 600;
    letter-spacing: -0.01em;
  }
  .volume_display {
    position: absolute;
    width: 100%;
    height: 150px;
    max-width: 250px;
    margin: var(--main-logo-margin-top) 0 0 0;
    background: var(--main-logo);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }
  .volume_display img {
    max-width: 250px;
  }
  .asset_menu .select-box__input-text img {
    width: 22px;
    height: 22px;
  }
`
const devCSS = css``

export const LvgGameHeaderStyled = styled.div`
  position: relative;
  margin-top: 70px;
  ${designerCSS}
  ${devCSS}
`
